import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

const evcsOrdersRouter = {
  path: '/evcs_orders',
  component: Management,
  redirect: '/evcs_orders/list',
  children: [
    {
      path: 'list',
      component: () => import('@/views/evcs_orders/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listEvcsOrders
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/evcs_orders/ListTable'),
          meta: {
            auth: Auth.listEvcsOrders,
            tabName: 'all'
          }
        },
        {
          path: 'starting',
          component: () => import('@/views/evcs_orders/ListTable'),
          meta: {
            auth: Auth.listEvcsOrders,
            tabName: 'starting'
          }
        },
        {
          path: 'charging',
          component: () => import('@/views/evcs_orders/ListTable'),
          meta: {
            auth: Auth.listEvcsOrders,
            tabName: 'charging'
          }
        },
        {
          path: 'stopping',
          component: () => import('@/views/evcs_orders/ListTable'),
          meta: {
            auth: Auth.listEvcsOrders,
            tabName: 'stopping'
          }
        },
        {
          path: 'finished',
          component: () => import('@/views/evcs_orders/ListTable'),
          meta: {
            auth: Auth.listEvcsOrders,
            tabName: 'finished'
          }
        },
        {
          path: 'unavailable',
          component: () => import('@/views/evcs_orders/ListTable'),
          meta: {
            auth: Auth.listEvcsOrders,
            tabName: 'unavailable'
          }
        }
      ]
    },
    {
      path: ':id',
      component: () => import('@/views/evcs_orders/DetailLayout'),
      redirect: ':id/detail',
      meta: {
        auth: Auth.showEvcsOrder
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/evcs_orders/details/Detail'),
          meta: {
            auth: Auth.showOrder,
            tabName: 'detail'
          }
        }
      ]
    }
  ]
}

export default evcsOrdersRouter
